"use client";
import React from "react";
import {
  Box,
  Center,
  Separator,
  Table,
  VStack,
  Text,
  Flex,
  SimpleGrid,
} from "@chakra-ui/react";
import { COLOCATION_DATA, COLOCATION_FOOTER_CONSTANTS } from "./constants";
import { Heading } from "@/elements";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import PricingFooter from "@/components/pricingFooter";

// Desktop Table View
export const DesktopView = () => {
  return (
    <Box overflowX="auto" w="100%">
      <Table.Root striped border={"2px solid rgb(237,242,247)"} width={"100%"}>
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader>Type</Table.ColumnHeader>
            <Table.ColumnHeader>Rack Space</Table.ColumnHeader>
            <Table.ColumnHeader>Power</Table.ColumnHeader>
            <Table.ColumnHeader>Free Remote Hands</Table.ColumnHeader>
            <Table.ColumnHeader>Location</Table.ColumnHeader>
            <Table.ColumnHeader>Contract Length</Table.ColumnHeader>
            <Table.ColumnHeader>Price / Month</Table.ColumnHeader>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {COLOCATION_DATA.map((colo, index) => (
            <Table.Row key={index} fontSize={"15px"} color="#2d3748">
              <Table.Cell>{colo.type}</Table.Cell>
              <Table.Cell>{colo.rackSpace}</Table.Cell>
              <Table.Cell>{colo.power}</Table.Cell>
              <Table.Cell>{colo.remoteHands}</Table.Cell>
              <Table.Cell>{colo.location}</Table.Cell>
              <Table.Cell>{colo.contractLength}</Table.Cell>
              <Table.Cell>
                <Text fontWeight={"700"} fontSize={"18px"} color="primary.200">
                  {colo.price}
                </Text>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </Box>
  );
};

// Mobile Card View
export const MobileView = () => {
  return (
    <SimpleGrid columns={{ base: 1, sm: 2 }} gap={6}>
      {COLOCATION_DATA.map((colo, index) => (
        <VStack
          key={index}
          borderRadius="lg"
          borderWidth="1px"
          borderColor="gray.200"
          boxShadow="md"
          gap={4}
          w="100%"
          p={4}
          bg="white"
        >
          <Text fontWeight="bold" fontSize="xl" color="primary.200">
            {colo.type}
          </Text>

          <Separator borderColor="gray.200" />

          <Flex direction="column" w="full">
            <Text fontSize="sm" color="text.100">
              Rack Space
            </Text>
            <Text fontWeight="medium" fontSize="md">
              {colo.rackSpace}
            </Text>
          </Flex>

          <Flex direction="column" w="full">
            <Text fontSize="sm" color="text.100">
              Power
            </Text>
            <Text fontWeight="medium" fontSize="md">
              {colo.power}
            </Text>
          </Flex>

          <Flex direction="column" w="full">
            <Text fontSize="sm" color="text.100">
              Free Remote Hands
            </Text>
            <Text fontWeight="medium" fontSize="md">
              {colo.remoteHands}
            </Text>
          </Flex>

          <Flex direction="column" w="full">
            <Text fontSize="sm" color="text.100">
              Location
            </Text>
            <Text fontWeight="medium" fontSize="md">
              {colo.location}
            </Text>
          </Flex>

          <Flex direction="column" w="full">
            <Text fontSize="sm" color="text.100">
              Contract Length
            </Text>
            <Text fontWeight="medium" fontSize="md">
              {colo.contractLength}
            </Text>
          </Flex>

          <Flex direction="column" w="full">
            <Text fontSize="sm" color="text.100">
              Price / Month
            </Text>
            <Text fontWeight="bold" fontSize="lg" color="primary.200">
              {colo.price}
            </Text>
          </Flex>
        </VStack>
      ))}
    </SimpleGrid>
  );
};

// Combined Component
const ColocationTable = () => {
  const HeadingVariant = useHeadingVariant();
  return (
    <Box id="colocation">
      <Heading variant={HeadingVariant} textAlign="center" mb={8}>
        Colocation Plans
      </Heading>
      <Center display={{ md: "none" }} w="full">
        <MobileView />
      </Center>
      <Box display={{ base: "none", md: "block" }}>
        <DesktopView />
      </Box>
      <PricingFooter {...COLOCATION_FOOTER_CONSTANTS} />
      <Separator borderWidth="2px" borderColor="#ECECEC" my={10} />
    </Box>
  );
};

export default ColocationTable;
